{
  "Accessibility Menu": "Menu Aksesibiliti",
  "Reset settings": "Tetapkan semula tetapan",
  "Close": "Tutup",
  "Content Adjustments": "Penyesuaian Kandungan",
  "Adjust Font Size": "Laraskan Saiz Fon",
  "Highlight Title": "Serlahkan Tajuk",
  "Highlight Links": "Serlahkan Pautan",
  "Readable Font": "Fon Mudah Baca",
  "Color Adjustments": "Penyesuaian Warna",
  "Dark Contrast": "Kontras Gelap",
  "Light Contrast": "Kontras Terang",
  "High Contrast": "Kontras Tinggi",
  "High Saturation": "Saturasi Tinggi",
  "Low Saturation": "Saturasi Rendah",
  "Monochrome": "Monokrom",
  "Contrast": "Kontras",
  "Invert Colors": "Balikkan warna",
  "Tools": "Peralatan",
  "Reading Guide": "Panduan Membaca",
  "Stop Animations": "Hentikan Animasi",
  "Big Cursor": "Kursor Besar",
  "Increase Font Size": "Besarkan Saiz Fon",
  "Decrease Font Size": "Kecilkan Saiz Fon",
  "Letter Spacing": "Ruangan Huruf",
  "Line Height": "Ketinggian Garis",
  "Font Weight": "Ketebalan Fon",
  "Dyslexia Font": "Fon Dyslexia",
  "Language": "Bahasa",
  "Open Accessibility Menu": "Buka menu kebolehcapaian",
  "Widget Settings": "Tetapan widget",
  "Widget Position": "Kedudukan widget",
  "Top Left": "Kiri atas",
  "Top Center": "Tengah atas",
  "Top Right": "Kanan atas",
  "Center Left": "Tengah kiri",
  "Center Right": "Tengah kanan",
  "Bottom Left": "Kiri bawah",
  "Bottom Center": "Tengah bawah",
  "Bottom Right": "Kanan bawah",
  "Screen Reader": "Pembaca skrin",
  "Voice Navigation": "Navigasi suara",
  "Custom Color": "Warna tersuai",
  "Change the site's colors": "Tukar warna laman",
  "Backgrounds": "Latar belakang",
  "Headings": "Tajuk",
  "Contents": "Kandungan",
  "Reset colors": "Tetapkan semula warna",
  "Image Desaturation": "Nyahketepuan imej",
  "Search languages": "Cari bahasa",
  "No languages found": "Tiada bahasa ditemui",
  "Accessibility Profiles": "Profil kebolehcapaian",
  "Motor Impaired": "Masalah pergerakan",
  "Big cursor, voice navigation, and no animations.": "Penuding besar, navigasi suara dan tiada animasi.",
  "Blind": "Buta",
  "Screen reader helpers with higher contrast.": "Pembantu pembaca skrin dengan kontras lebih tinggi.",
  "Color Blind": "Buta warna",
  "High contrast palette with desaturated media.": "Palet kontras tinggi dengan media kurang tepu.",
  "Dyslexia": "Disleksia",
  "Friendly font, extra spacing, stronger weight.": "Fon mesra, jarak tambahan dan tulisan lebih tebal.",
  "Low vision": "Penglihatan rendah",
  "Dark contrast and 130% magnification.": "Kontras gelap dan pembesaran 130%.",
  "Cognitive & Learning": "Kognitif & pembelajaran",
  "Highlights key sections and enables voice help.": "Menonjolkan bahagian utama dan mengaktifkan bantuan suara.",
  "Seizure & Epileptic": "Sawan & epilepsi",
  "Stops animations and desaturates imagery.": "Menghentikan animasi dan mengurangkan warna imej.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Panduan membaca, pautan diserlahkan dan palet lebih tenang.",
  "Widget Size": "Saiz Widget",
  "Default": "Lalai",
  "Medium": "Sederhana",
  "Small": "Kecil",
  "Color Blindness": "Buta Warna",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Akromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Mensimulasikan dan membantu pengguna dengan kekurangan penglihatan warna."
}
